(function() {
  const initSubmenuSlider = () => {
    const submenu_swiper = document.querySelectorAll('.carousel__slider-sus-collection-submenu');
    submenu_swiper.forEach((slider, index) => {
      const submenuSlider = new Swiper(slider, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        watchSlidesProgress: true,
        simulateTouch: true, 
        autoHeight: true,
        speed: 500,
        navigation: {
          nextEl: ".carousel__slider-nav .swiper-button-next",
          prevEl: ".carousel__slider-nav .swiper-button-prev",
        }
      })
    })
  }
  initSubmenuSlider();
})()